const decode = async (base64: string) => {
  // 1. Restore Base64 padding and characters
  const base64Standard = base64.replace(/-/g, '+').replace(/_/g, '/');
  const binaryString = atob(base64Standard);

  // 2. Convert binary string to a Uint8Array
  const bytes = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));

  // 3. Decompress using DecompressionStream
  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
  const decompressedResponse = await new Response(stream).text();

  // 4. Parse back to JSON
  return JSON.parse(decompressedResponse);
};

const encode = async (data: object) => {
  const json = JSON.stringify(data);
  const stream = new Blob([json]).stream().pipeThrough(new CompressionStream('gzip'));
  const compressedBytes = await new Response(stream).arrayBuffer();
  const base64 = btoa(String.fromCharCode(...new Uint8Array(compressedBytes)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

  return base64;
};

export const Decoder = {
  decode,
  encode,
};
